module.exports = __webpack_public_path__ + "static/footerbg-2071d9964e584f8837855b6b452cc863.jpg";